import { render, staticRenderFns } from "./platformEdit.vue?vue&type=template&id=ff667984&scoped=true&"
import script from "./platformEdit.vue?vue&type=script&lang=js&"
export * from "./platformEdit.vue?vue&type=script&lang=js&"
import style0 from "./platformEdit.vue?vue&type=style&index=0&id=ff667984&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff667984",
  null
  
)

export default component.exports